import React, { useMemo } from 'react';
import {
  string, shape, object, arrayOf,
} from 'prop-types';
import some from 'lodash/some';
import isEmpty from 'lodash/isEmpty';
import AddressInfo from '../AddressInfo';

const shippingAddress = ({ paymentResultList }) => {
  const isAddressExist = useMemo(() => some(paymentResultList, ({ billingContact }) => {
    return !isEmpty(billingContact);
  }), [ paymentResultList ]);

  if (paymentResultList.length === 0 || !isAddressExist) {
    return null;
  }
  return (
    <div className="external-info__address-info">
      {
        paymentResultList.map(({ billingContact }, idx) => {
          const shouldNotRenderSection = isEmpty(billingContact);
          if (shouldNotRenderSection) {
            return null;
          }

          return <AddressInfo key={idx} addressInfo={billingContact} title={'checkout.lib.components.paymentResult.detail.billingInfo.title'}/>;
        })
      }
    </div>
  );
};

shippingAddress.propTypes = {
  paymentResultList: arrayOf(shape({
    billingContact: shape({
      firstName: string,
      lastName: string,
      address: object,
      email: string,
    }),
  })),
};

shippingAddress.defaultProps = {
  paymentResultList: [],
};

export default shippingAddress;
